import React from 'react';
import { IconButton, Grid, styled, Box } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { translations } from '../../translations/common';
import { 
  StyledDrawer, 
  DrawerHeader, 
  MainContent as Content, 
  FilterFab 
} from '../../routes/styles/InvoicesStyles';

interface FilterDrawerProps {
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  filterContent: React.ReactNode;
}

const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& .MuiIconButton-root': {
    color: theme.palette.primary.main,
  }
}));

export const FilterDrawer: React.FC<FilterDrawerProps> = ({
  open,
  onToggle,
  children,
  filterContent,
}) => {
  return (
    <div>
      <Content open={open}>
        <FilterFab
          color="primary"
          variant="extended"
          onClick={onToggle}
          size="small"
          aria-label="toggle filter drawer"
        >
          {translations.common.filter}
        </FilterFab>
        {children}
      </Content>
      <StyledDrawer
        anchor="right"
        open={open}
        onClose={onToggle}
        variant="persistent"
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
        >
          < HeaderContainer>
            <IconButton 
              onClick={onToggle} 
              size="large" 
              aria-label="close filter"
              sx={{ marginRight: 2 }}
            >
              <ChevronRightIcon />
            </IconButton>
            <Box sx={{ flexGrow: 1, fontWeight: 'bold' }}>
              {translations.common.filter}
            </Box>
          </HeaderContainer>
          <Grid>{filterContent}</Grid>
        </Grid>
      </StyledDrawer>
      <DrawerHeader />
    </div>
  );
}; 